import { useRef } from 'react'
import { useStore } from '../store'
import type { LogoPos } from '../types'

const POSITIONS: { key: LogoPos; label: string }[] = [
  { key: 'tl', label: '↖' },
  { key: 'tr', label: '↗' },
  { key: 'bl', label: '↙' },
  { key: 'br', label: '↘' },
]

/** Bảng điều khiển chèn logo: upload ảnh, chọn góc, kích thước, độ mờ. */
export function LogoPanel() {
  const inputRef = useRef<HTMLInputElement>(null)
  const logo = useStore((s) => s.logo)
  const setLogoFile = useStore((s) => s.setLogoFile)
  const clearLogo = useStore((s) => s.clearLogo)
  const setLogoPos = useStore((s) => s.setLogoPos)
  const setLogoScale = useStore((s) => s.setLogoScale)
  const setLogoOpacity = useStore((s) => s.setLogoOpacity)

  return (
    <div className="logopanel">
      <div className="logopanel-head">🖼️ Logo / Watermark</div>

      {!logo.url ? (
        <button className="btn small" onClick={() => inputRef.current?.click()}>
          ➕ Tải logo (PNG trong suốt)
        </button>
      ) : (
        <div className="logo-controls">
          <div className="logo-preview">
            <img src={logo.url} alt="logo" />
            <button className="btn small ghost" onClick={clearLogo}>
              Xóa
            </button>
          </div>

          <div className="ctrl-row">
            <label>Vị trí</label>
            <div className="pos-grid">
              {POSITIONS.map((p) => (
                <button
                  key={p.key}
                  className={`pos-btn ${logo.pos === p.key ? 'active' : ''}`}
                  onClick={() => setLogoPos(p.key)}
                >
                  {p.label}
                </button>
              ))}
            </div>
          </div>

          <div className="ctrl-row">
            <label>Kích thước {Math.round(logo.scale * 100)}%</label>
            <input
              type="range"
              min={5}
              max={40}
              value={Math.round(logo.scale * 100)}
              onChange={(e) => setLogoScale(Number(e.target.value) / 100)}
            />
          </div>

          <div className="ctrl-row">
            <label>Độ mờ {Math.round(logo.opacity * 100)}%</label>
            <input
              type="range"
              min={10}
              max={100}
              value={Math.round(logo.opacity * 100)}
              onChange={(e) => setLogoOpacity(Number(e.target.value) / 100)}
            />
          </div>
        </div>
      )}

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        hidden
        onChange={(e) => {
          const f = e.target.files?.[0]
          if (f) setLogoFile(f)
          e.target.value = ''
        }}
      />
    </div>
  )
}
